import { render } from "./GeojsonTableSynth.vue?vue&type=template&id=a1bb3e8a"
import script from "./GeojsonTableSynth.vue?vue&type=script&lang=js"
export * from "./GeojsonTableSynth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__